module.exports = __webpack_public_path__ + "static/media/logistics-brikk-preview.84e1be5e.png";